/**
 * @generated SignedSource<<62dbb3ecb0a3c1d9aab1d0ea97ab3827>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type HideItem_tab$data = {
  readonly __id: string;
  readonly id: string;
  readonly " $fragmentType": "HideItem_tab";
};
export type HideItem_tab$key = {
  readonly " $data"?: HideItem_tab$data;
  readonly " $fragmentSpreads": FragmentRefs<"HideItem_tab">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "HideItem_tab",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "id"
      },
      "action": "THROW",
      "path": "id"
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "kind": "RequiredField",
          "field": {
            "kind": "ScalarField",
            "name": "__id"
          },
          "action": "THROW",
          "path": "__id"
        }
      ]
    }
  ],
  "type": "JiraNavigationItem",
  "abstractKey": "__isJiraNavigationItem"
};

(node as any).hash = "2e58297399f7217bc7b0f7b7efcfd8cc";

export default node;
